export const envName: keyof typeof envSet = process.env.VUE_APP_DATASET as any
import { u2kFilters, u2kV2Filters } from './env/u2k'

abstract class EnvSet {
    abstract filters: Array<{ short: string, value: string, type?: string }>
    abstract releases: ReleaseList

    dataUrl = '../data'
    abstract databaseService: boolean
    mustLogin = true
    get defaultActiveReruns() {
        return this.releases.default.reruns.slice()
    }

    hscMapData(rerun: string) {
        return `${this.dataUrl}/${rerun}`
    }
}

interface IReleaseOptions {
    reruns: string[]
    cutoutUrl?: string
    cas?: boolean
    cas_release?: string
}

export class Release {
    readonly reruns: string[]
    readonly cutoutUrl?: string
    readonly cas: boolean

    constructor(readonly name: string, readonly options: IReleaseOptions) {
        this.reruns = options.reruns
        this.cutoutUrl = options.cutoutUrl
        this.cas = !!options.cas
    }

    get defaultRerun() {
        return this.reruns[0]
    }

    get defaultFilter() {
        return 'HSC-I'
    }

    get cas_release() {
        return this.options.cas_release || this.name
    }

    static list(rs: Release[]) {
        const list = new ReleaseList()
        list.push(...rs)
        return list
    }
}

class ReleaseList extends Array<Release> {
    get default() {
        return this[0]
    }

    get cas() {
        return this.filter((r) => r.cas)
    }

    get cutout() {
        return this.filter((r) => r.cutoutUrl)
    }
}


const envSet = {
    'hscla': class extends EnvSet {
        filters: Array<{ short: string, value: string, type?: string }> = [
            { short: 'g', value: 'HSC-G' },
            { short: 'r', value: 'HSC-R' },
            { short: 'i', value: 'HSC-I' },
            { short: 'z', value: 'HSC-Z' },
            { short: 'y', value: 'HSC-Y' },
            { short: "387", value: "NB0387", type: "narrow" },
            { short: "468", value: "NB0468", type: "narrow" },
            { short: "515", value: "NB0515", type: "narrow" },
            { short: "656", value: "NB0656", type: "narrow" },
            { short: "816", value: "NB0816", type: "narrow" },
            { short: "921", value: "NB0921", type: "narrow" },
        ]
        releases = Release.list([
            new Release('hscla2016', {
                reruns: ['la2016'],
                cas: true,
                cutoutUrl: '/das_cutout/la2016/cgi-bin/cutout',
            }),
            new Release('hscla2014', {
                reruns: ['la2014'],
                cas: true,
                cutoutUrl: '/das_cutout/la2014/cgi-bin/cutout',
            }),
            new Release('pdr3', {
                reruns: ['pdr3_wide', 'pdr3_dud'],
            }),
            new Release('pdr2', {
                reruns: ['pdr2_wide', 'pdr2_dud'],
            }),
            new Release('pdr1', {
                reruns: ['pdr1_wide', 'pdr1_deep', 'pdr1_udeep'],
            }),
        ])
        databaseService = true
        dataUrl = `${location.protocol}//hscmap.mtk.nao.ac.jp/hscMap4/data`
    },
    'u2k': class extends EnvSet {
        filters: Array<{ short: string, value: string, type?: string }> = u2kFilters
        releases = Release.list([
            new Release('u2k', {
                cas: true,
                reruns: ['s18a_dud_u2k'],
                cutoutUrl: '/das_quarry/dr2.1/cgi-bin/cutout',
            }),
        ])
        databaseService = true
    },
    'u2k_v2': class extends EnvSet {
        filters: Array<{ short: string, value: string, type?: string }> = u2kV2Filters
        releases = Release.list([
            new Release('u2k_v2', {
                cas: false,
                reruns: ['u2k_v2_elais', 'u2k_v2_deep2f3'],
                cutoutUrl: '/das_quarry/dr2.1/cgi-bin/cutout',
            }),
        ])
        databaseService = false
    },
    'public-release-3': class extends EnvSet {
        filters: Array<{ short: string, value: string, type?: string }> = [
            { short: 'g', value: 'HSC-G' },
            { short: 'r', value: 'HSC-R' },
            { short: 'i', value: 'HSC-I' },
            { short: 'z', value: 'HSC-Z' },
            { short: 'y', value: 'HSC-Y' },
            { short: '387', value: 'NB0387', type: 'narrow' },
            { short: '816', value: 'NB0816', type: 'narrow' },
            { short: '921', value: 'NB0921', type: 'narrow' },
        ]
        releases = Release.list([
            new Release('pdr3', {
                reruns: ['pdr3_wide', 'pdr3_dud'],
                cas: true,
                cutoutUrl: '/das_cutout/pdr3/cgi-bin/cutout',
            }),
            new Release('pdr2', {
                reruns: ['pdr2_wide', 'pdr2_dud'],
                cas: true,
                cutoutUrl: '/das_cutout/pdr2/cgi-bin/cutout',
            }),
            new Release('pdr1', {
                reruns: ['pdr1_wide', 'pdr1_deep', 'pdr1_udeep'],
                cas: true,
                cutoutUrl: '/das_quarry/cgi-bin/quarryImage',
            }),
            new Release('s16a', {
                reruns: ['s16a_wide', 's16a_deep', 's16a_udeep'],
            }),
        ])
        databaseService = true
        dataUrl = `${location.protocol}//hscmap.mtk.nao.ac.jp/hscMap4/data`
    },
    'public-release-2': class extends EnvSet {
        filters: Array<{ short: string, value: string, type?: string }> = [
            { short: 'g', value: 'HSC-G' },
            { short: 'r', value: 'HSC-R' },
            { short: 'i', value: 'HSC-I' },
            { short: 'z', value: 'HSC-Z' },
            { short: 'y', value: 'HSC-Y' },
            { short: '387', value: 'NB0387', type: 'narrow' },
            { short: '816', value: 'NB0816', type: 'narrow' },
            { short: '921', value: 'NB0921', type: 'narrow' },
        ]
        releases = Release.list([
            new Release('pdr2', {
                reruns: ['pdr2_wide', 'pdr2_dud'],
                cas: true,
                cutoutUrl: '/das_cutout/pdr2/cgi-bin/cutout',
            }),
            new Release('pdr1', {
                reruns: ['pdr1_wide', 'pdr1_deep', 'pdr1_udeep'],
                cas: true,
                cutoutUrl: '/das_quarry/cgi-bin/quarryImage',
            }),
            new Release('s16a', {
                reruns: ['s16a_wide', 's16a_deep', 's16a_udeep'],
            }),
        ])
        databaseService = true
        dataUrl = `${location.protocol}//hscmap.mtk.nao.ac.jp/hscMap4/data`
    },
    'public-release-2-chorus': class extends EnvSet {
        filters: Array<{ short: string, value: string, type?: string }> = [
            { short: 'g', value: 'HSC-G' },
            { short: 'r', value: 'HSC-R' },
            { short: 'i', value: 'HSC-I' },
            { short: 'z', value: 'HSC-Z' },
            { short: 'y', value: 'HSC-Y' },
            { short: '387', value: 'NB0387', type: 'narrow' },
            { short: '816', value: 'NB0816', type: 'narrow' },
            { short: '921', value: 'NB0921', type: 'narrow' },
            // chorus
            { short: '527', value: 'NB0527', type: 'narrow' },
            { short: '718', value: 'NB0718', type: 'narrow' },
            { short: '945', value: 'IB0945', type: 'narrow' },
            { short: '973', value: 'NB0973', type: 'narrow' },
        ]
        releases = Release.list([
            new Release('pdr2', {
                reruns: ['pdr2_wide', 'pdr2_dud'],
                cas: true,
                cutoutUrl: '/das_cutout/pdr2/cgi-bin/cutout',
            }),
            new Release('chorus', {
                reruns: ['chorus-s18a-da908ee467204a79'],
            }),
            new Release('pdr1', {
                reruns: ['pdr1_wide', 'pdr1_deep', 'pdr1_udeep'],
                cas: true,
                cutoutUrl: '/das_quarry/cgi-bin/quarryImage',
            }),
            new Release('s16a', {
                reruns: ['s16a_wide', 's16a_deep', 's16a_udeep'],
            }),
        ])
        databaseService = true
        dataUrl = `${location.protocol}//hscmap.mtk.nao.ac.jp/hscMap4/data`
    },
    'hscmap': class extends EnvSet {
        filters: Array<{ short: string, value: string, type?: string }> = [
            { short: 'g', value: 'HSC-G' },
            { short: 'r', value: 'HSC-R' },
            { short: 'i', value: 'HSC-I' },
            { short: 'z', value: 'HSC-Z' },
            { short: 'y', value: 'HSC-Y' },
            { short: '816', value: 'NB0816', type: 'narrow' },
            { short: '921', value: 'NB0921', type: 'narrow' },
        ]
        releases = Release.list([
            new Release('pdr3', {
                reruns: ['pdr3_wide', 'pdr3_dud'],
            }),
            new Release('pdr2', {
                reruns: ['pdr2_wide', 'pdr2_dud'],
            }),
            new Release('pdr1', {
                reruns: ['pdr1_wide', 'pdr1_deep', 'pdr1_udeep'],
            }),
            // new Release('s16a', {
            //     reruns: ['s16a_wide', 's16a_deep', 's16a_udeep'],
            // }),
        ])
        databaseService = false
        mustLogin = false
        dataUrl = `${location.protocol}//hscmap.mtk.nao.ac.jp/hscMap4/data`
    },
    'internal-release': class extends EnvSet {
        filters: Array<{ short: string, value: string, type?: string }> = [
            { short: 'g', value: 'HSC-G' },
            { short: 'r', value: 'HSC-R' },
            { short: 'i', value: 'HSC-I' },
            { short: 'z', value: 'HSC-Z' },
            { short: 'y', value: 'HSC-Y' },
            { short: '387', value: 'NB0387', type: 'narrow' },
            { short: '816', value: 'NB0816', type: 'narrow' },
            { short: '921', value: 'NB0921', type: 'narrow' },
            { short: '1010', value: 'NB1010', type: 'narrow' },
            { short: 'u', value: 'MegaCam-u' },
            { short: 'u*', value: 'MegaCam-uS' },
            { short: 'j', value: 'WFCAM-J' },
            { short: 'k', value: 'WFCAM-K' },
        ]
        releases = Release.list([
            new Release('dr4', {
                reruns: ['s21a_wide', 's21a_dud2', 's21a_dud_old'],
                cas: true,
                cas_release: 'dr4-citus',
                cutoutUrl: '/das_quarry/dr4/cgi-bin/cutout',
            }),
            new Release('dr3', {
                // reruns: ['s20a_wide', 's20a_dud', 's20a_wide-localsky', 's20a_dud-localsky', 's19a_wide', 's19a_dud', 's19a_wide-localsky', 's19a_dud-localsky'],
                reruns: ['s20a_wide', 's20a_dud2', 's20a_dud_old', 's19a_wide', 's19a_dud'],
                cas: true,
                cas_release: 'dr3-citus',
                cutoutUrl: '/das_quarry/dr3/cgi-bin/cutout',
            }),
            new Release('dr2', {
                reruns: ['s18a_wide', 's18a_dud'],
                cas: true,
                cutoutUrl: '/das_quarry/dr2.1/cgi-bin/cutout',
            }),
            new Release('dr1', {
                cas: true,
                reruns: ['s16a_clauds_deep', 's16a_clauds_udeep_deep_depth', 's16a_deep_ukidss'],
            }),
            new Release('pdr1', { reruns: ['pdr1_wide', 'pdr1_deep', 'pdr1_udeep'] }),
        ])
        databaseService = true
        get defaultActiveReruns() { return ['s21a_wide', 's21a_dud2'] }
    },
}

// @ts-ignore
if (envSet[process.env.VUE_APP_DATASET] === undefined) {
    alert(`invalid envName = ${process.env.VUE_APP_DATASET}`)
}

export const env = new envSet[envName]()
